import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const appApi = createApi({
	reducerPath: "appApi",
	keepUnusedDataFor: 0,
	baseQuery: fetchBaseQuery({
		// baseUrl: `${process.env.REACT_APP_SERVER_URL}`,
		prepareHeaders: (headers, { getState }) => {
			// const token = getState().auth.token;
			// if (token) {
			// 	headers.set("authorization", `Bearer ${token}`);
			// }
			return headers;
		},
	}),

	endpoints: (builder) => ({
		getItems: builder.query({
			query: () => ({
				url: `settings.json`,
				method: "GET",
			}),
			transformResponse: (response) => response,
		}),
	}),
});

export const { useGetItemsQuery } = appApi;
